import api from './api';

const brokerService = {
    getAll: () => api.get('/admin/brokers'),
    getById: (id) => api.get(`/admin/brokers/${id}`),
    create: (data) => api.post('/admin/brokers', data),
    update: (id, data) => api.put(`/admin/brokers/${id}`, data),
    delete: (id) => api.delete(`/admin/brokers/${id}`),
    toggleActive: (id) => api.patch(`/admin/brokers/${id}/toggle-active`),
    uploadLogo: (id, file) => {
        const formData = new FormData();
        formData.append('logo', file);
        return api.post(`/admin/brokers/${id}/logo`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
    },
};

export default brokerService;
